
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs,
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ql-fill",attrs:{"d":"M11.759 2.482a2.561 2.561 0 00-3.53.607A7.656 7.656 0 006.8 6.2c-.691 2.988-1.525 8.477-2.65 8.727a1.545 1.545 0 00-1.3-.933.922.922 0 00-.85 1.042S1.954 16 4.119 16s3.091-2.691 3.7-5.553c.177-.826.36-1.726.554-2.6L8.775 6.2c.381-1.421.807-2.521 1.306-2.676a1.014 1.014 0 001.02.56.966.966 0 00.658-1.602z"}}),_c('rect',{staticClass:"ql-fill",attrs:{"height":"1.6","rx":".8","ry":".8","width":"5","x":"5.15","y":"6.2"}}),_c('path',{staticClass:"ql-fill",attrs:{"d":"M13.663 12.027a1.662 1.662 0 01.266-.276q.193.069.456.138a2.1 2.1 0 00.535.069 1.075 1.075 0 00.767-.3 1.044 1.044 0 00.314-.8.84.84 0 00-.238-.619.8.8 0 00-.594-.239 1.154 1.154 0 00-.781.3 4.607 4.607 0 00-.781 1q-.091.15-.218.346l-.246.38c-.068-.288-.137-.582-.212-.885-.459-1.847-2.494-.984-2.941-.8-.482.2-.353.647-.094.529a.869.869 0 011.281.585c.217.751.377 1.436.527 2.038a5.688 5.688 0 01-.362.467 2.69 2.69 0 01-.264.271q-.221-.08-.471-.147a2.029 2.029 0 00-.522-.066 1.079 1.079 0 00-.768.3 1.058 1.058 0 00-.317.813.82.82 0 00.832.852 1.134 1.134 0 00.787-.3 5.11 5.11 0 00.776-.993q.141-.219.215-.34c.046-.076.122-.194.223-.346a2.786 2.786 0 00.918 1.726 2.582 2.582 0 002.376-.185c.317-.181.212-.565 0-.494a.807.807 0 01-.951-.051 5.159 5.159 0 01-.913-2.446q.224-.314.4-.527z"}})])
          )
        }
      }
    